export default {
    CHAMPIONSHIPS: {
        TAEKWONDO: [{
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'bronze',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'bronze',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'bronze',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }, {
            'medal': 'gold',
        }]
    }
}
